import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {InsolesSummaryModel} from './insolesSummary.model';
import {LovValueSummaryConverter} from '../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {AccountSummaryConverter} from '../../../../account/common/api.converter/AccountSummary.converter';
import {EntityWithAuditMetadataConverter} from '../../../../common/converter/entityWithAuditMetadata.converter';
import {DateConverter} from '../../../../common/converter/date.converter';
import {ValueAndLabelConverter} from "../../../../common/converter/ValueAndLabel.converter";
import {PartnerSummaryConverter} from "../../../../partner/common/api/converter/partnerSummary.converter";
import {InsolesSummaryCamDocumentConverter} from "./InsolesSummaryCamDocument.converter";
import {InsoleMaterialSummaryConverter} from "../../../material/api/entity/insoleMaterialSummary.converter";
import {AddressConverter} from "../../../../common/converter/address.converter";
import {ProviderSummaryConverter} from "../../../../provider/common/api/entity/converter/providerSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesSummaryConverter extends HttpModelConverter<InsolesSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private dateConverter: DateConverter,
                private entityWithAuditMetadataConverter: EntityWithAuditMetadataConverter,
                private valueAndLabelConverter: ValueAndLabelConverter,
                private partnerSummaryConverter: PartnerSummaryConverter,
                private camDocumentConverter: InsolesSummaryCamDocumentConverter,
                private insoleMaterialSummaryConverter: InsoleMaterialSummaryConverter,
                private addressConverter: AddressConverter,
                private providerSummaryConverter: ProviderSummaryConverter) {
        super();
    }

    protected createInstance(): InsolesSummaryModel {
        return new InsolesSummaryModel();
    }

    protected enrichObject(result: InsolesSummaryModel, src: InsolesSummaryModel) {
        result.customerAccount = new AccountSummaryConverter().convert(src.customerAccount);
        result.color = this.lovValueSummaryConverter.convert(src.color);
        result.material = this.insoleMaterialSummaryConverter.convert(src.material)
        result.symmetry = this.lovValueSummaryConverter.convert(src.symmetry);
        result.symmetrySubType = this.lovValueSummaryConverter.convert(src.symmetrySubType);
        result.providerModel = this.valueAndLabelConverter.convert(src.providerModel);
        result.patient = this.partnerSummaryConverter.convert(src.patient);
        result.feet = this.lovValueSummaryConverter.convert(src.feet);
        result.covering = this.valueAndLabelConverter.convert(src.covering);
        result.productionDeadline = this.dateConverter.convert(src.productionDeadline);
        result.expectedDeliveryDate = this.dateConverter.convert(src.expectedDeliveryDate);
        result.orderedAt = this.dateConverter.convert(src.orderedAt);
        result.cadWorkflowProcessStatus = this.lovValueSummaryConverter.convert(src.cadWorkflowProcessStatus);
        this.entityWithAuditMetadataConverter.convert(result, src);
        result.status = this.lovValueSummaryConverter.convert(src.status);
        result.camMethod = this.lovValueSummaryConverter.convert(src.camMethod);
        result.renewType = this.lovValueSummaryConverter.convert(src.renewType);
        result.deliveryAddress = this.addressConverter.convert(src.deliveryAddress);
        result.provider = this.providerSummaryConverter.convert(src.provider);
    }
}
